import { Cookies } from '../constants/cookies';
import { useCookie } from 'nuxt/app';

export function isMarketingConsentApproved() {

  try {
    const cookieName = 'CookieInformationConsent';
    const cookieValue = document
      ? document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${cookieName}=`))
        ?.split('=')[1]
      : JSON.stringify( useCookie('CookieInformationConsent')?.value);

    const decodedJsonString = decodeURIComponent(cookieValue || '');
    const parsedJson = JSON.parse(decodedJsonString);

    if ('consents_approved' in parsedJson) {
      const consentsApproved = parsedJson.consents_approved;
      return consentsApproved.some((element: string) => element.includes(Cookies.COOKIE_INFORMATION_MARKETING_CONSENT));
    }

    return false;

  } catch (error) {
    return false;
  }
}
